import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiCheck,
  FiPlus,
} from 'react-icons/fi';
import './WizboxLandingPage.css';

const img = (name) => `/landing_img/${name}`;

const assets = {
  logo: img('wizbox_logo_session_1_12.png'),
  platformSide: img('create_publish_side_img_session_2.png'),
  dashboard: img('side_image_session_3.png'),
  chat: img('side_image_session_4.png'),
  dotSide: img('green_dot_side_session_4.png'),
  dotBottom: img('green_dot_bottom_session_4.png'),
  sourcing: img('candidate_sourcing_session_5.png'),
  matching: img('ai_matching_session_5.png'),
  calendar: img('automated_interview_session_5.png'),
  workspace: img('shared_hiring_session_5.png'),
  centerLogo: img('center_log_session_6.png'),
  cta: img('image 90.png'),
  integrations: {
    gmail: img('mail_session_7.png'),
    linkedin: img('linkedin_session_7.png'),
    g2: img('g_session_7.png'),
    whatsapp: img('wahtsapp_session_7.png'),
    source: img('naukri_session_7.png'),
    indeed: img('indeed_session_7.png'),
    slack: img('slark_session_7.png'),
    calendar: img('calender_session_7.png'),
    meet: img('meet_session_7.png'),
  },
  logos: {
    curox: img('company_1_session_9.png'),
    galara: img('company_2_session_9.png'),
    nexyia: img('company_3_session_9.png'),
    flowdive: img('company_4_session_9.png'),
  },
  avatars: [
    img('person_1_session_9.png'),
    img('person_2_session_9.png'),
    img('person_3_session_9.png'),
    img('person_4_session_9.png'),
    img('person_1_session_9.png'),
  ],
  security: {
    encryption: img('data_encryption_session_10.png'),
    access: img('access_control_session_10.png'),
    privacy: img('privacy_session_10.png'),
    audit: img('audit_log_session_10.png'),
  },
};

const platformCards = [
  {
    icon: img('create_publish_jobs_icon_session_2.png'),
    title: 'Create & Publish Jobs in Minutes',
    text: 'Generate role descriptions with AI and publish multiple job boards from one place.',
    visual: 'jobs',
  },
  {
    icon: img('source_engage_icon_session_2.png'),
    title: 'Source & Engage Talent from One Place',
    text: 'Find candidates, review profiles, and start personalized outreach without switching tools.',
  },
  {
    icon: img('source_engage_icon_session_2.png'),
    title: 'Coordinate Interviews Without the Chaos',
    text: 'Manage screening, collaboration, scheduling, and communication in one seamless workflow.',
  },
];

const steps = [
  ['Define the Role', 'Tell WizBox who you are hiring for. Share your requirements in plain language, and WizBox helps refine the role, responsibilities, and hiring criteria.', img('define_role_session_3.png')],
  ['Create & Publish Jobs', 'Turn the confirmed JD into job posts for the right channels.', img('create_publish_session_3.png')],
  ['Source & Engage Talent', 'Find matching candidates and move them into outreach.', img('source_session_3.png')],
  ['Interview & Hire', 'Coordinate scheduling, feedback, and hiring decisions.', img('interview_session_3.png')],
];

const flowSteps = ['JD Creation', 'Multi-Channel Posting', 'Candidate Sourcing', 'Personalized Outreach', 'Interview Scheduling'];

const workspaceCards = [
  {
    title: 'Unified Candidate Sourcing',
    text: 'Source talent from LinkedIn, Naukri, referrals, and internal databases in one workflow.',
    kind: 'sourcing',
  },
  {
    title: 'AI Matching & Engagement',
    text: 'Automatically rank candidates, personalize outreach, and follow up at the right time.',
    kind: 'matching',
  },
  {
    title: 'Shared Hiring Workspace',
    text: 'Keep recruiters, hiring managers, candidate activity, and feedback in one collaborative workspace.',
    kind: 'workspace',
  },
  {
    title: 'Automated Interview Coordination',
    text: 'Schedule interviews, sync calendars, and reduce manual recruiter coordination.',
    kind: 'calendar',
  },
];

const workflowRows = [
  ['Job description creation and editing tools', 'Start the entire hiring process through one conversation'],
  ['Candidate sourcing and talent search platforms', 'Specialized AI agents handle tasks behind the scenes'],
  ['Multiple job boards for posting open roles', 'Centralized candidate profiles and hiring activity'],
  ['Applicant Tracking System (ATS) for pipeline management', 'Automated workflows from sourcing to scheduling'],
  ['Interview scheduling and calendar coordination software', 'A single workspace for every hiring operation'],
];

const plans = [
  {
    name: 'Starter',
    price: '₹4,999',
    suffix: '/month',
    text: 'The perfect start for growing teams.',
    features: ['Dedicated access for one recruiter', 'Run up to 5 hiring workflows', 'Publish up to 20 openings every month', 'Responsive support via email'],
    action: 'Choose Plan',
  },
  {
    name: 'Most Popular - Pro',
    price: '₹12,999',
    suffix: '/month',
    text: 'For in-house teams scaling 10-50 hires a year.',
    features: ['Built for teams of up to 5 users', 'Unlimited active hiring sessions', '200 job posts every month', 'Native ATS integrations', 'Advanced hiring analytics and reporting'],
    action: 'Start Free Trial',
    featured: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    suffix: '',
    text: 'For agencies and enterprises with custom needs.',
    features: ['Unlimited team members & recruiter seats', 'Secure access with complete visibility', 'Dedicated Customer Success Manager', 'Enterprise SLA & DPA included'],
    action: 'Talk to Sales',
  },
];

const testimonials = [
  ['Curox', assets.logos.curox, 'Candidate sourcing is faster and better organized. Instead of switching between profiles, our teams finally review candidates that are relevant to the role.', 'Riya Rao', 'HR Manager'],
  ['Galara', assets.logos.galara, 'The biggest advantage is having everything in one place. Job creation, candidate sourcing, screening, and interview coordination happen through a single workflow.', 'Priya Nair', 'Founder & CEO'],
  ['Nexyia', assets.logos.nexyia, 'We went from spending days writing job descriptions and sourcing candidates to having qualified profiles in our pipeline within hours.', 'Arjun Mehta', 'Head of Talent Acquisition'],
  ['FlowDive', assets.logos.flowdive, 'Managing multiple hiring mandates used to mean juggling spreadsheets and ATS tools. WizBox consolidated everything into one workspace.', 'Sarah Thompson', 'Managing Director'],
  ['Zentora', null, 'What impressed us most was the simplicity. New recruiters became productive from day one with minimal training.', 'Daniel Brooks', 'Director of People'],
];

const securityCards = [
  ['Data Encryption', 'All data encrypted in transit and at rest.', assets.security.encryption],
  ['Access Controls', 'Granular permissions for teams and agencies.', assets.security.access],
  ['Privacy Compliance', 'GDPR & DPDPA aligned data practices.', assets.security.privacy],
  ['Audit Logs', 'Track every hiring action with transparency.', assets.security.audit],
];

const faqs = [
  'Does WizBox replace my ATS?',
  'How does the AI source candidates - is it just LinkedIn scraping?',
  'Where does my candidate data live?',
  'Can I customize the AI outreach message?',
  'Does it work for non-tech roles?',
];

function JobVisual() {
  return (
    <div className="wz-job-visual image-frame">
      <img src={assets.platformSide} alt="Create and publish jobs preview" />
    </div>
  );
}

function DashboardVisual() {
  return (
    <div className="wz-dashboard-visual image-frame">
      <img src={assets.dashboard} alt="WizBox dashboard preview" />
    </div>
  );
}

function ChatPreview() {
  return (
    <div className="wz-chat-preview image-frame">
      <img className="dot-side" src={assets.dotSide} alt="" />
      <img className="dot-bottom" src={assets.dotBottom} alt="" />
      <img src={assets.chat} alt="Create JD with WizBox AI" />
    </div>
  );
}

function WorkspaceMock({ kind }) {
  if (kind === 'workspace') {
    return (
      <div className="wz-workspace-image tall">
        <img src={assets.workspace} alt="Shared hiring workspace preview" />
      </div>
    );
  }
  if (kind === 'calendar') {
    return (
      <div className="wz-workspace-image wide">
        <img src={assets.calendar} alt="Automated interview coordination preview" />
      </div>
    );
  }
  const source = kind === 'matching' ? assets.matching : assets.sourcing;
  return (
    <div className="wz-workspace-image">
      <img src={source} alt={`${kind} preview`} />
    </div>
  );
}

function Orbit() {
  return (
    <div className="wz-orbit" aria-label="Hiring integrations">
      <span className="ring one" />
      <span className="ring two" />
      <span className="ring three" />
      <div className="wz-orbit-core"><img src={assets.centerLogo} alt="WizBox" /></div>
      <i className="icon gmail"><img src={assets.integrations.gmail} alt="Gmail" /></i>
      <i className="icon meet"><img src={assets.integrations.meet} alt="Google Meet" /></i>
      <i className="icon linkedin"><img src={assets.integrations.linkedin} alt="LinkedIn" /></i>
      <i className="icon whatsapp"><img src={assets.integrations.whatsapp} alt="WhatsApp" /></i>
      <i className="icon calendar"><img src={assets.integrations.calendar} alt="Google Calendar" /></i>
      <i className="icon search"><img src={assets.integrations.source} alt="Naukri" /></i>
      <i className="icon indeed"><img src={assets.integrations.indeed} alt="Indeed" /></i>
      <i className="icon slack"><img src={assets.integrations.slack} alt="Slack" /></i>
      <i className="icon charts"><img src={assets.integrations.g2} alt="Hiring analytics" /></i>
    </div>
  );
}

function CtaIllustration() {
  return (
    <div className="wz-cta-illustration image-frame">
      <img src={assets.cta} alt="AI hiring illustration" />
    </div>
  );
}

export default function WizboxLandingPage() {
  const navigate = useNavigate();
  const [testimonialIndex, setTestimonialIndex] = useState(2);
  const goLogin = () => navigate('/auth/login?role=recruiter');
  const goSignup = () => navigate('/auth/signup?role=recruiter');
  const visibleTestimonials = useMemo(() => (
    testimonials.map((item, index) => ({ item, index }))
  ), []);
  const moveTestimonials = (direction) => {
    setTestimonialIndex((current) => {
      const next = current + direction;
      if (next < 0) return testimonials.length - 1;
      if (next >= testimonials.length) return 0;
      return next;
    });
  };

  return (
    <main className="wz-landing-v2">
      <section className="wz-hero-v2">
        <nav className="wz-nav-v2">
          <button type="button" className="wz-logo" onClick={() => navigate('/landing-v2')}><img src={assets.logo} alt="WizBox" /></button>
          <div><a href="#products">Products</a><a href="#solutions">Solutions</a><a href="#pricing">Pricing</a></div>
          <aside><button type="button" onClick={goLogin}>Sign In</button><button type="button" onClick={goSignup}>Request a demo</button></aside>
        </nav>
        <div className="wz-hero-copy-v2">
          <h1>Hire Smarter. Move Faster.<span>All in One Chat.</span></h1>
          <p>Built for recruiters who want speed, clarity, and better hires without the operational overload.</p>
          <div><button type="button" onClick={goSignup}>Book a demo</button><button type="button" onClick={goLogin}>Get free trial</button></div>
        </div>
      </section>

      <section className="wz-section-v2 wz-platform-v2" id="products">
        <header className="split-head"><h2>Hiring Doesn't Need Five Different Platforms.</h2><p>Recruiting teams shouldn't juggle platforms to get one role filled. Everything should happen in <strong>one connected workflow</strong> powered by AI.</p></header>
        <div className="platform-grid-v2">
          {platformCards.map((card) => (
            <article key={card.title} className={card.visual ? 'wide' : ''}>
              <span className="lime-icon"><img src={card.icon} alt="" /></span>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
              {card.visual === 'jobs' && <JobVisual />}
            </article>
          ))}
        </div>
      </section>

      <section className="wz-section-v2 wz-steps-v2">
        <header className="center-head"><h2>Start Hiring in 4 Simple Steps</h2><p>From role creation to interview scheduling, WizBox helps recruiters move faster with one connected workflow.</p></header>
        <div className="steps-layout-v2">
          <DashboardVisual />
          <div className="step-list-v2">{steps.map(([title, text, icon], index) => <article key={title} className={index === 0 ? 'active' : ''}><span><img src={icon} alt="" /></span><div><h3>{title}</h3><p>{text}</p></div></article>)}</div>
        </div>
      </section>

      <section className="wz-section-v2 wz-chat-v2">
        <header className="center-head"><h2>One Chat. The Entire Hiring Workflow.</h2><p>WizBox orchestrates specialized AI agents behind a single conversation so recruiters can move from job creation to interview scheduling without switching tools, tabs, or workflows.</p></header>
        <div className="flow-line-v2">{flowSteps.map((step, index) => <div key={step} className={index === 0 ? 'active' : ''}><span>{String(index + 1).padStart(2, '0')}</span><p>{step}</p></div>)}</div>
        <div className="chat-card-v2">
          <div><span>JD CREATION</span><h3>Create job descriptions that attract the right talent.</h3><p>WizBox AI understands your requirements, asks the right questions, and generates a structured, compelling JD that's ready to publish.</p><ul><li><FiCheck /> Role clarity with intelligent discovery</li><li><FiCheck /> Skills, responsibilities and qualifications covered</li><li><FiCheck /> Brand-aligned, bias-free job descriptions</li></ul></div>
          <ChatPreview />
        </div>
      </section>

      <section className="wz-dark-v2" id="solutions">
        <header className="center-head"><h2>One workspace. Every hiring workflow.</h2><p>Source candidates, screen resumes, manage interviews, and track progress from a single platform designed for high-performing teams.</p></header>
        <div className="workspace-grid-v2">
          {workspaceCards.map((card) => <article key={card.title} className={card.kind}><h3>{card.title}</h3><p>{card.text}</p><WorkspaceMock kind={card.kind} /></article>)}
        </div>
      </section>

      <section className="wz-section-v2 wz-table-section">
        <header className="center-head"><h2>One workflow. Not seven tabs.</h2><p>See how consolidating your recruiting tools can reduce costs, save time, and simplify every stage of hiring.</p></header>
        <div className="workflow-table-v2">
          <div className="head"><span>WITHOUT WIZBOX</span><span>WITH WIZBOX</span></div>
          {workflowRows.map(([left, right]) => <div className="row" key={left}><span>× {left}</span><span>✓ {right}</span></div>)}
        </div>
      </section>

      <section className="wz-section-v2 wz-stack-v2">
        <div><h2>Works With Your Existing Hiring Stack</h2><p>Connect WizBox with your ATS, job boards, calendars, and communication tools to keep your hiring workflow seamless and connected.</p><button type="button" onClick={goSignup}>Get started</button></div>
        <Orbit />
      </section>

      <section className="wz-pricing-v2" id="pricing">
        <header className="center-head"><h2>Choose the Plan That Grows With Your Hiring</h2><p>Start free for 14 days and discover a simpler way to hire. No credit card needed.</p></header>
        <div className="pricing-grid-v2">{plans.map((plan) => <article key={plan.name} className={plan.featured ? 'featured' : ''}><h3>{plan.name}</h3><p>{plan.text}</p><ul>{plan.features.map((feature) => <li key={feature}><FiCheck /> {feature}</li>)}</ul><strong>{plan.price}<small>{plan.suffix}</small></strong><button type="button" onClick={plan.featured ? goSignup : goLogin}>{plan.action}</button></article>)}</div>
      </section>

      <section className="wz-testimonials-v2">
        <header className="center-head"><h2>Trusted by Teams That Hire Faster</h2><p>See how recruiters, agencies, and growing companies use WizBox to streamline hiring and fill roles with less effort.</p></header>
        <div className="testimonial-window-v2">
          <div className="testimonial-strip-v2" style={{ transform: `translateX(${(2 - testimonialIndex) * 268}px)` }}>
            {visibleTestimonials.map(({ item: [company, logo, quote, name, role], index }) => (
              <article key={company} className={index === testimonialIndex ? 'featured' : ''}>
                {logo ? <img className="testimonial-logo" src={logo} alt={company} /> : <h3>{company}</h3>}
                <p>"{quote}"</p>
                <div><img className="testimonial-avatar" src={assets.avatars[index]} alt={name} /><strong>{name}<small>{role}</small></strong></div>
              </article>
            ))}
          </div>
        </div>
        <div className="carousel-dots">
          <button type="button" onClick={() => moveTestimonials(-1)} aria-label="Previous testimonial">‹</button>
          {testimonials.map((item, index) => <button type="button" key={item[0]} className={index === testimonialIndex ? 'dot active' : 'dot'} onClick={() => setTestimonialIndex(index)} aria-label={`Show ${item[0]} testimonial`} />)}
          <button type="button" onClick={() => moveTestimonials(1)} aria-label="Next testimonial">›</button>
        </div>
      </section>

      <section className="wz-section-v2 wz-security-v2">
        <header className="split-head"><h2>Your Hiring Data Stays Protected</h2><p>WizBox combines intelligent hiring automation with the security, privacy, and governance enterprises expect.</p></header>
        <div className="security-grid-v2">{securityCards.map(([title, text, icon]) => <article key={title}><span className="lime-icon"><img src={icon} alt="" /></span><h3>{title}</h3><p>{text}</p></article>)}</div>
      </section>

      <section className="wz-faq-v2">
        <header className="center-head"><h2>Frequently Asked Questions</h2></header>
        <div>{faqs.map((faq) => <details key={faq}><summary>{faq}<FiPlus /></summary><p>Yes. WizBox is designed to support the complete recruiting workflow while keeping control in your hands.</p></details>)}</div>
      </section>

      <section className="final-cta-v2">
        <CtaIllustration />
        <div><h2>Ready to hire faster with AI?</h2><p>Set up WizBox in minutes and start sourcing, screening, and managing candidates from one workspace.</p><button type="button" onClick={goSignup}>Book a demo</button><button type="button" onClick={goLogin}>Join free trial</button></div>
      </section>

      <section className="wz-footer-wrap-v2">
        <footer className="footer-v2">
          <div><button type="button" className="wz-logo footer-logo" onClick={() => navigate('/landing-v2')}><img src={assets.logo} alt="WizBox" /></button><p>WizBox is an AI-powered hiring platform that helps teams source, screen, and hire top talent faster.</p><form><input placeholder="Enter your email" /><button type="button">Subscribe</button></form></div>
          <nav><strong>Product</strong><a href="#products">Features</a><a href="#solutions">Plans</a><a href="#pricing">Pricing</a><a href="#products">Roadmap</a></nav>
          <nav><strong>Resources</strong><a href="#solutions">Documentation</a><a href="#products">Integrations</a><a href="#faq">Blog</a><a href="#pricing">Help center</a></nav>
          <nav><strong>Company</strong><button type="button" onClick={goLogin}>About</button><button type="button" onClick={goSignup}>Careers</button><button type="button">Contact</button><button type="button">Terms</button></nav>
        </footer>
      </section>
    </main>
  );
}
